import { isBlockingOutage, type OutageStatus, useOutageStatus } from '@solinkcorp/authentication';
import { CommonContext } from 'components/Contexts';
import { useContext } from 'react';

export const isMajorOutage = (status: OutageStatus | undefined) =>
  status && isBlockingOutage(status.status.indicator);
export const isMinorOutage = (status: OutageStatus | undefined) =>
  status && status.status.indicator === 'minor';

/**
 * Returns true if a banner that occupies layout space is currently shown.
 */
export const useIsBannerShown = (): boolean => {
  const { appState } = useContext(CommonContext);
  const outageStatus = useOutageStatus();
  return isMinorOutage(outageStatus) || appState.showIntegrationBanner;
};
